export default "__VITE_ASSET__DPKYqBnt__"